// Lightweight memoized selector factory without external dependencies.
// Returns a selector function (state, subrequestId) => subrequest | null
export const makeGetSubrequest = () => {
  let lastSubrequests = null;
  let lastId = null;
  let lastResult = null;

  return (state, subrequestId) => {
    const subrequests = state?.querystringsearch?.subrequests;

    // If neither the subrequests object nor the id changed, return cached result
    if (subrequests === lastSubrequests && subrequestId === lastId) {
      return lastResult;
    }

    lastSubrequests = subrequests;
    lastId = subrequestId;
    lastResult = subrequests?.[subrequestId] || null;
    return lastResult;
  };
};
